import { render, staticRenderFns } from "./DumpAreaFormRepeater.vue?vue&type=template&id=effb1f38&scoped=true"
import script from "./DumpAreaFormRepeater.vue?vue&type=script&lang=js"
export * from "./DumpAreaFormRepeater.vue?vue&type=script&lang=js"
import style0 from "./DumpAreaFormRepeater.vue?vue&type=style&index=0&id=effb1f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effb1f38",
  null
  
)

export default component.exports